import { render, staticRenderFns } from "./MediaInTemplateCard.vue?vue&type=template&id=b0c5299e&"
import script from "./MediaInTemplateCard.vue?vue&type=script&lang=js&"
export * from "./MediaInTemplateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports